module.exports = __webpack_public_path__ + "img/webpack.a6be13ea.png";